module.exports = __webpack_public_path__ + "79c651331fa31495b54bd8e5d9ca9ee8.jpg";